// src/components/AddOddzial.js
import React, { useState, useContext, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { useMediaQuery } from "react-responsive";
import { baseURL } from "../../utils/api";

const AddOddzial = ({ onAddSuccess }) => {
  const toast = useRef(null);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { user, token } = useContext(AuthContext);
  const [skrot, setSkrot] = useState("");
  const [adres, setAdres] = useState("");
  // Lista oddziałów (pobrana z serwera) – dodajemy też pole "dostepny"
  const [oddzialy, setOddzialy] = useState([]);
  // Rejestrujemy oddział, który jest edytowany
  const [editingOddzial, setEditingOddzial] = useState(null);
  // Domyślnie wyświetlamy tylko oddziały dostępne; przycisk pozwala na pokazanie wszystkich
  const [showAll, setShowAll] = useState(false);

  // Dodawanie nowego oddziału – nowy oddział dodajemy jako dostępny (dostepny: true)
  const handleSubmit = () => {
    const newOddzial = { skrot, adres, dostepny: true };
    // Sprawdź, czy oddział o podanym adresie już istnieje (bez względu na status dostępności)
    if (oddzialy.some((o) => o.adres === adres)) {
      alert("Oddział o podanym adresie już istnieje");
    } else {
      axios
        .post(`${baseURL}api/oddzialyAdd`, newOddzial, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          console.log("Dodano oddział:", response.data);
          setSkrot("");
          setAdres("");
          setOddzialy([...oddzialy, response.data]);
          onAddSuccess();
        })
        .catch((error) => {
          console.error("Błąd dodawania oddziału:", error);
        });
    }
  };

  useEffect(() => {
    axios
      .get(`${baseURL}api/egz`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setOddzialy(response.data))
      .catch((error) => console.error("Błąd pobierania oddziałów:", error));
  }, [token]);

  // Zmiana statusu dostępności – dostępna tylko podczas edycji
  const handleToggleAvailability = (oddzial) => {
    if (editingOddzial && editingOddzial.id === oddzial.id) {
      setEditingOddzial({
        ...editingOddzial,
        dostepny: !editingOddzial.dostepny,
      });
    }
  };

  // Rozpoczęcie edycji oddziału
  const handleEditClick = (oddzial) => {
    setEditingOddzial({ ...oddzial });
  };

  // Zapis zmian edytowanego oddziału (w tym statusu dostępności)
  const handleSaveClick = () => {
    axios
      .put(`${baseURL}api/oddzialy/${editingOddzial.id}`, editingOddzial, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        console.log("Zaktualizowano oddział:", response.data);
        setOddzialy(
          oddzialy.map((o) => (o.id === editingOddzial.id ? response.data : o))
        );
        setEditingOddzial(null);
        toast.current.show({
          severity: "success",
          summary: "Sukces",
          detail: "Oddział zaktualizowany",
        });
        onAddSuccess();
      })
      .catch((error) => {
        console.error("Błąd aktualizacji oddziału:", error);
      });
  };

  const handleCancelClick = () => {
    setEditingOddzial(null);
    toast.current.show({
      severity: "info",
      summary: "Anulowano",
      detail: "Anulowano edycję oddziału",
    });
  };

  // Renderowanie komórek – pola edytowalne lub zwykłe
  const textBodyTemplate = (rowData, field) => {
    if (editingOddzial && editingOddzial.id === rowData.id) {
      return (
        <InputText
          value={editingOddzial[field] || ""}
          onChange={(e) =>
            setEditingOddzial({ ...editingOddzial, [field]: e.target.value })
          }
        />
      );
    }
    return rowData[field];
  };

  // Kolumna "Dostępny" – checkbox edytowalny tylko w trybie edycji, poza tym disabled
  const availabilityBodyTemplate = (rowData) => {
    if (editingOddzial && editingOddzial.id === rowData.id) {
      return (
        <Checkbox
          checked={editingOddzial.dostepny}
          onChange={() => handleToggleAvailability(rowData)}
        />
      );
    } else {
      return <Checkbox checked={rowData.dostepny} disabled />;
    }
  };

  // Kolumna z przyciskami edycji i zapisu/anulowania
  const actionBodyTemplate = (rowData) => {
    if (editingOddzial && editingOddzial.id === rowData.id) {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-save"
            className="p-button-success p-mr-2"
            onClick={handleSaveClick}
          />
          <Button
            icon="pi pi-times"
            className="p-button-secondary"
            onClick={handleCancelClick}
          />
        </React.Fragment>
      );
    } else {
      return (
        <Button
          // label="Edytuj"
          icon="pi pi-pencil"
          className="p-button-text p-button-sm"
          onClick={() => handleEditClick(rowData)}
        // className="p-button-warning"
        />
      );
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="add-form">
        <h3>Dodaj nowy oddział</h3>
        <div className="add-input">
          <label>Skrót (wyświetlany na WZ):</label>
          <InputText value={skrot} onChange={(e) => setSkrot(e.target.value)} />
        </div>
        <div className="add-input">
          <label>Miejscowość:</label>
          <InputText value={adres} onChange={(e) => setAdres(e.target.value)} />
        </div>
        <Button
          label="Dodaj oddział"
          onClick={handleSubmit}
          disabled={!skrot || !adres}
        />
      </div>
      <Button
        label={showAll ? "Pokaż tylko dostępne" : "Pokaż wszystkie"}
        onClick={() => setShowAll(!showAll)}
        style={{ margin: "1rem 0" }}
      />
      {isMobile && (
        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          <i>
            W celu uzyskania lepszej widoczności danych, skorzystaj z orientacji
            poziomej
          </i>
        </div>
      )}
      <DataTable
        value={showAll ? oddzialy : oddzialy.filter((o) => o.dostepny)}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 15]}
        selectionMode="single"
        style={{ marginTop: "30px" }}
      >
        <Column
          header="Skrót"
          field="skrot"
          sortable
          body={(rowData) => textBodyTemplate(rowData, "skrot")}
        />
        <Column
          header="Miejscowość"
          field="adres"
          sortable
          body={(rowData) => textBodyTemplate(rowData, "adres")}
        />
        <Column
          header="Dostępny"
          field="dostepny"
          sortable
          body={availabilityBodyTemplate}
          headerStyle={{ textAlign: "center", width: "7rem" }}
          bodyStyle={{ textAlign: "center" }}
        />
        {user?.role === "Administrator" && (
          <Column header="Akcje" body={actionBodyTemplate} />
        )}
      </DataTable>
    </div>
  );
};

export default AddOddzial;
